import comp from "./RadioButton";
export default comp;
